import { css, LayoutDanko, LayoutHerodias, LayoutJay, styled } from "@lux/ds";

export const StyledDanko = styled(LayoutDanko)(
  ({ theme }) => css`
    background-color: ${theme.palette.primary.shade[98]};
    height: 100%;
    grid-template-rows: minmax(88px, max-content) 1fr 54px;
    overflow: hidden;
  `,
);

export const StyledHeaderJay = styled(LayoutJay)(
  ({ theme }) => css`
    background: ${theme.palette.primary.shade[100]};
    box-shadow: 0px 2px 6px 0px #1b181b0f;
    height: max-content;
    gap: unset;
    z-index: 10;
  `,
);

export const StyledHerodias = styled(LayoutHerodias)(
  ({ theme }) => css`
    height: unset;
    justify-content: space-between;
    padding: ${theme.space.m} ${theme.space.l};
  `,
);

export const StyledActionHerodias = styled(LayoutHerodias)`
  height: unset;
  width: max-content;
`;

export const StyledContentJay = styled(LayoutJay, {
  shouldForwardProp: (props) => props !== "$padded",
})<{
  $padded: boolean;
}>(
  ({ $padded, theme }) => css`
    &::-webkit-scrollbar {
      display: none;
    }

    background: ${theme.palette.primary.shade[98]};
    ${$padded
      ? css`
          padding: ${theme.space.m} ${theme.space.l};
        `
      : ""}
  `,
);

export const StyledFooterHerodias = styled(LayoutHerodias)(
  ({ theme }) => css`
    background: ${theme.palette.common.white};
    box-shadow: 0px -2px 6px 0px #1b181b0f;
    height: unset;
    padding: 14px ${theme.space.l};
  `,
);

export const LabelFooterSide = styled(LayoutHerodias)(
  () => css`
    justify-content: flex-start;
  `,
);

export const ButtonFooterSide = styled(LayoutHerodias)(
  () => css`
    justify-content: flex-end;
  `,
);
